export default __webpack_public_path__ + "static/media/posts.441502be.svg";